


















import { Component, Vue } from 'vue-property-decorator';

interface TrustSymbol {
  id: number;
  image: string;
  title: string;
}

@Component
export default class TrustSymbols extends Vue {
  name: 'TrustSymbols'

  trustSymbols: Array<TrustSymbol> = [{
    id: 1,
    title: 'Gameservercheck',
    image: 'css/customer/img/chk.png',
  }, {
    id: 2,
    title: 'ESL certified',
    image: 'css/customer/img/esl.png',
  }, {
    id: 3,
    title: 'Pingperfect',
    image: 'css/customer/img/p.png',
  }];
}
